export default {
  id: null,
  analiseTecID: null,
  origemItem: null,
  ordem: null,
  sequencia: null,
  descricao: null,
  tipoItem: 0,
  tipoAgrupamento: 0,
  valor: null,
  unidade: null,
  codigoCliente: null,
  descricaoCliente: null,
  quantidade: null,
  observacao: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/tecanalysisitemmodel.js